module.exports = __webpack_public_path__ + "img/mascot_logo_238_mascot only.jpg";